<template>
  <div class="w-full">
    <a-spin :spinning="spinning">
      <div v-if="bidderInfo.project" class="m-auto text-base" :style="{ width: '750px' }">
        <div
          class="w-full px-4 my-4 text-xl text-left border-4 border-t-0 border-b-0 border-r-0 border-blue-400 border-solid text-bold"
          :style="{ width: '750px' }"
        >
          项目信息
        </div>
        <div class="w-full py-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            项目名称:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidderInfo.project }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            招标人:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidderInfo.proprietor }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            担保额度:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidderInfo.money ? bidderInfo.money.toFixed(2) : '' }}
            <span class="text-red-500">
              {{ convertCurrency(parseFloat(bidderInfo.money ? bidderInfo.money.toFixed(2) : '')) }}
            </span>
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            担保费:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidderInfo.poundage ? bidderInfo.poundage.toFixed(2) : '' }}
            <span class="text-red-500">
              {{
                convertCurrency(
                  parseFloat(bidderInfo.poundage ? bidderInfo.poundage.toFixed(2) : ''),
                )
              }}
            </span>
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            保证金截止时间:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidderInfo.kbdate }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left leading-8 text-right text-gray-400" :style="{ width: '200px' }">
            推荐码:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            <a-input v-model="r_code" placeholder="(选填)" style="width: 200px" />
          </div>
        </div>
        <div
          class="w-full px-4 my-4 text-xl text-left border-4 border-t-0 border-b-0 border-r-0 border-blue-400 border-solid text-bold"
          :style="{ width: '750px' }"
        >
          企业信息
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            投标企业名称:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidderInfo.bidder }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            统一社会信用代码:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidderInfo.taxNumber }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left leading-8 text-right text-gray-400" :style="{ width: '200px' }">
            <span class="leading-8 text-red-500">*</span>
            联系人:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            <a-select
              style="width: 200px"
              placeholder="请选择联系人"
              v-model="contact_id"
              @select="contactselect"
            >
              <a-select-option v-for="(item, index) in contact" :key="index" :value="item.id">{{
                item.name
              }}</a-select-option>
            </a-select>
            <a-button type="primary" class="ml-6" @click="contactFlag = true">管理</a-button>
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            营业地址:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ selectcontact.address }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            联系人号码:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ selectcontact.phone_number }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }"> 邮箱: </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ selectcontact.email }}
          </div>
        </div>
        <a-form
          :form="form"
          v-bind="formItemLayout"
          v-if="!(companyinfo.license && companyinfo.certificate_src)"
        >
          <a-row>
            <a-col :span="10">
              <a-form-item label="营业执照">
                <div class="overflow-hidden">
                  <a-input
                    v-show="false"
                    v-decorator="[
                      'license',
                      {
                        rules: [{ required: !disabled, message: '请上传营业执照' }],
                      },
                    ]"
                  ></a-input>
                  <Upload
                    :disabled="disabled"
                    :src="companyinfo.license"
                    @upload="licenseUpload"
                  ></Upload>
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="开户许可证" class="flex">
                <div class="overflow-hidden">
                  <a-input
                    v-show="false"
                    v-decorator="[
                      'certificate_src',
                      {
                        rules: [{ required: !disabled, message: '请上传开户许可证' }],
                      },
                    ]"
                  ></a-input>
                  <Upload
                    :disabled="disabled"
                    :src="companyinfo.certificate_src"
                    @upload="certUpload"
                  ></Upload>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item label="企业名称" v-if="false">
            <a-textarea
              v-decorator="[
                'owner',
                { rules: [{ required: !disabled, message: '请输入企业名称' }] },
              ]"
              :disabled="disabled"
              autoSize
            ></a-textarea>
          </a-form-item>
          <a-form-item label="社会信用代码" v-if="false">
            <a-textarea
              v-decorator="[
                'taxNumber',
                {
                  rules: [{ required: !disabled, message: '请输入社会信用代码' }],
                },
              ]"
              :disabled="disabled"
              autoSize
            ></a-textarea>
          </a-form-item>
          <a-form-item label="法人代表">
            <a-textarea
              v-decorator="[
                'legal_person',
                { rules: [{ required: !disabled, message: '请输入法人代表' }] },
              ]"
              :disabled="disabled"
              autoSize
            ></a-textarea>
          </a-form-item>
          <a-form-item label="地址">
            <a-textarea
              v-decorator="['address', { rules: [{ required: !disabled, message: '请输入地址' }] }]"
              :disabled="disabled"
              autoSize
            ></a-textarea>
          </a-form-item>
          <a-form-item label="开户行">
            <a-textarea
              v-decorator="[
                'bankName',
                { rules: [{ required: !disabled, message: '请输入开户行' }] },
              ]"
              :disabled="disabled"
              autoSize
            ></a-textarea>
          </a-form-item>
          <a-form-item label="开户企业名称">
            <a-textarea
              v-decorator="[
                'name',
                {
                  rules: [{ required: !disabled, message: '请输入开户企业名称' }],
                },
              ]"
              :disabled="disabled"
              autoSize
            ></a-textarea>
          </a-form-item>
          <a-form-item label="开户行账号">
            <a-textarea
              v-decorator="[
                'bankAccount',
                {
                  rules: [{ required: !disabled, message: '请输入开户行账号' }],
                },
              ]"
              :disabled="disabled"
              autoSize
            ></a-textarea>
          </a-form-item>
        </a-form>
        <div class="overflow-hidden text-sm" :style="{ width: '750px' }">
          <div class="float-left h-2" :style="{ width: '200px' }"></div>
          <div class="float-left">
            <a-checkbox v-model="agreement">您已阅读并同意</a-checkbox>
            <span class="text-red-500 cursor-pointer" @click="agreementFlag = true"
              >《电子保函申请书》</span
            >
          </div>
        </div>
        <div class="justify-center w-full py-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left h-2" :style="{ width: '200px' }"></div>
          <a-button class="float-left" type="primary" @click="doContract" :disabled="!agreement">
            提交申请
          </a-button>
        </div>
      </div>
    </a-spin>
    <a-modal
      :visible="agreementFlag"
      title="《电子保函申请书》"
      :width="595"
      :footer="null"
      :bodyStyle="{ padding: 0 }"
      @cancel="agreementFlag = false"
    >
      <div
        v-html="agreementText"
        style="padding: 30px 57px; height: calc(100vh - 300px); overflow-y: scroll"
      ></div>
    </a-modal>
    <Contact
      ggb="liaoning"
      :taxNumber="bidderInfo.taxNumber"
      :visible="contactFlag"
      @cancel="() => (contactFlag = false)"
      @refresh="getContacts(false)"
      @select="contactSelect"
    ></Contact>
    <ContactForm
      ggb="liaoning"
      :taxNumber="bidderInfo.taxNumber"
      :visible="contactFormFlag"
      @cancel="() => (contactFormFlag = false)"
      @ok="getContacts(false)"
    ></ContactForm>
  </div>
</template>

<script>
  import Upload from '@/components/Upload/index';
  import { GgbTemp, SaveContract } from '@/api/ggb/linhai';
  import { contacts, last_contact } from '@/api/contact';
  import { licenseocr, cert_ocr, ggbCompanysava } from '@/api/company';
  import { user_company } from '@/api/user';
  import { convertCurrency, transContentLinHai } from '@/utils/transContent';
  import Contact from '@/views/ggb/common/contact/index.vue';
  import ContactForm from '@/views/ggb/common/contact/form.vue';
  import bus from '@/utils/bus';
  import { pick } from 'lodash';
  export default {
    components: {
      Contact,
      ContactForm,
      Upload,
    },
    props: {
      reopen: Number,
      bidderInfo: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        agreement: false,
        spinning: false,
        tempInfo: {},
        agreementFlag: false,
        r_code: '',
        contact: [],
        contactFlag: false,
        contactFormFlag: false,
        contact_id: undefined,
        selectcontact: {},
        info: {},
        companyinfo: {},
        formItemLayout: {
          labelCol: { span: 6 },
          wrapperCol: { span: 13 },
        },
        disabled: false,
        form: this.$form.createForm(this, { name: 'company' }),
        licenseocrres: {},
        certocrres: {},
      };
    },

    async mounted() {
      this.tempInfo = await GgbTemp('liaoning');
      // if (this.$route.query.code) {
      //   this.r_code = this.$route.query.code;
      // }
      this.companyinfo = (await user_company()) || {};
    },
    computed: {
      agreementText() {
        return this.tempInfo.agreement
          ? transContentLinHai(this.tempInfo.agreement, this.bidderInfo)
          : '';
      },
    },
    watch: {
      'bidderInfo.taxNumber'(a) {
        if (a) {
          this.getContacts(true);
        }
      },
      companyinfo(a) {
        if (a.id) {
          let companyinfo = Object.assign({}, a, { name: a.owner });
          setTimeout(() => {
            this.form.setFieldsValue(companyinfo);
          }, 10);
        } else {
          setTimeout(() => {
            this.form.resetFields();
          }, 10);
        }
      },
    },

    methods: {
      async licenseUpload(res) {
        try {
          setTimeout(() => this.form.setFieldsValue({ license: res.pathname }), 1);
          this.licenseocrres = await licenseocr(res.id);
          console.log(this.licenseocrres);
          let ocrrespick = pick(this.licenseocrres, [
            'address',
            'taxNumber',
            'owner',
            'legal_person',
          ]);
          setTimeout(() => this.form.setFieldsValue(ocrrespick), 1);
        } catch (error) {
          this.$message.error(error);
        }
      },
      async certUpload(res) {
        try {
          setTimeout(() => this.form.setFieldsValue({ certificate_src: res.pathname }), 1);
          this.certocrres = await cert_ocr(res.id);
          console.log(this.certocrres);
          let ocrrespick = pick(this.certocrres, ['bankAccount', 'bankName']);
          ocrrespick.name = this.certocrres.owner;
          setTimeout(() => this.form.setFieldsValue(ocrrespick), 1);
        } catch (error) {
          this.$message.error(error);
        }
      },
      async getContacts(isfirst) {
        this.contact =
          (
            await contacts({
              current: -1,
              qp: JSON.stringify({ eq: { taxNumber: this.bidderInfo.taxNumber } }),
            })
          ).data || [];
        if (isfirst) {
          if (this.contact.length == 0) {
            this.contactFormFlag = true;
          } else if (this.contact.length == 1) {
            this.contact_id = this.contact[0].id;
            this.selectcontact = this.contact[0];
          } else {
            let contract = await last_contact({
              ggb: 'liaoning',
              taxNumber: this.bidderInfo.taxNumber,
            });
            if (contract && contract.contact_id) {
              this.contact_id = contract.contact_id;
              this.selectcontact =
                this.contact.find((e) => {
                  return e.id == contract.contact_id;
                }) || {};
            }
          }
        }
      },
      convertCurrency,
      contactSelect(record) {
        this.contact_id = record.id;
        this.selectcontact = record;
      },
      contactselect(id) {
        this.contact_id = id;
        this.selectcontact =
          this.contact.find((e) => {
            return e.id == id;
          }) || {};
      },
      async doContract(e) {
        if (!this.contact_id) {
          this.$message.error('请选择联系人');
          return;
        }
        e.preventDefault();
        this.form.validateFieldsAndScroll(async (err, values) => {
          if (!err) {
            // if (this.licenseocrres.owner != this.certocrres.owner) {
            //   this.$message.warning('开户许可证和营业执照不匹配,请重新上传');
            //   return;
            // }
            // if (this.certocrres.owner != this.bidderInfo.bidder) {
            //   this.$message.warning('投标企业名称和营业执照不匹配,请重新上传');
            //   return;
            // }
            // if (this.licenseocrres.taxNumber != this.bidderInfo.taxNumber) {
            //   this.$message.warning('统一社会信用代码和营业执照不匹配,请重新上传');
            //   return;
            // }
            try {
              this.spinning = true;
              if (!(this.companyinfo.license && this.companyinfo.certificate_src)) {
                let companydata = Object.assign(this.companyinfo, values);
                console.log(companydata);
                await ggbCompanysava(companydata);
                this.info.bankName = this.companyinfo.bankName;
                this.info.bankAccount = this.companyinfo.bankAccount;
                this.info.companyAddress = this.companyinfo.address;
                this.info.legal_person = this.companyinfo.legal_person;
              }
              this.info = await SaveContract(
                Object.assign(this.bidderInfo, {
                  r_code: this.r_code,
                  contact_id: this.contact_id,
                }),
              );
              bus.$emit('tosetp2', this.info);
              this.$emit('next');
            } catch (error) {
              this.$message.error(error);
            } finally {
              this.spinning = false;
            }
          } else {
            console.log(values);
          }
        });
      },
    },
  };
</script>
